import { render, staticRenderFns } from "./TaxeForm.vue?vue&type=template&id=3fc9090d"
import script from "./TaxeForm.vue?vue&type=script&lang=js"
export * from "./TaxeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports